import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Stibbel from './pages/Stibbel';
import Home from './pages/Home';
import Proximity from './pages/Proximity';
import WeatherApp from './pages/weatherApp';
import "./App.scss"
import Newmotion from './pages/Newmotion';

// import { Detail } from './Pages/Detail';

function App() {
  return (
    <>
      {/* <header>This is header</header> */}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="newmotion" element={<Newmotion />} />
        <Route path="stibbel" element={<Stibbel />} />
        <Route path="proximity" element={<Proximity />} />
        <Route path="weatherapp" element={<WeatherApp />} />
      </Routes>

    </>
  );
}
export default App;
